require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./tapd-in-instagram-shoppable-posts.json") })
        }
      }, "path---tapd-in-instagram-shoppable-posts");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---tapd-in-instagram-shoppable-posts!./.cache/json/tapd-in-instagram-shoppable-posts.json
// module id = 856
// module chunks = 231608221292675